import { TableAlign } from '../../components/Table'

// These values match keys which come from BE so don't change them
export enum DividendValueProperty {
  Amount = 'Amount',
  Yield = 'Yield',
  Payout = 'Payout',
}

export const HISTORY_COLUMNS = [
  {
    id: 'Exdate' as const,
    name: 'Ex-date',
    align: TableAlign.Left,
  },
  {
    id: 'Ordinary' as const,
    name: 'Amount',
    align: TableAlign.Right,
  },
  {
    id: 'Special' as const,
    name: 'Special',
    align: TableAlign.Right,
  },
]

export const BAR_WIDTH = 72
export const CHART_HEIGHT = 250
export const LABELS_WIDTH = 28
export const LABELS_MARGIN = 22
export const BAR_WIDTH_NARROW = 52
export const BAR_GAP = 16
export const EXTRA_WIDTH = 44
export const CHART_MARGINS = { top: 0, right: 0, bottom: 0, left: 0 }
